import React from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Box, Text } from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import BuscadorArticulos from '../../../articulos/containers/BuscadorArticulos';
import {
  addArticulo,
  seleccionarMonturaGafaGraduada
} from '../../../../state/actions/creators/encargos.creador.actioncreator';
import ResumenEncargo from '../../containers/creador/ResumenEncargo.datadisplay';
import Page from '../../../shared/components/layout/Page.layout';
import { isTablet, isTotem } from '../../../../helpers/device.helper';

class EncargosCrearSeleccionarArticuloPage extends React.Component {
  componentDidMount() {
    const { encargo, history } = this.props;
    if (encargo === undefined) history.goBack();
  }

  render() {
    const {
      estructuraId, addArticulo, encargoUUID, linea, history, cdgtipo, modoSeleccionGafa, seleccionarMonturaGafaGraduada,
    } = this.props;
    const gluedFilter = {
      obsoleto: { valor: 'F', operador: 'eq' },
    };
    if (estructuraId) {
      gluedFilter.estructura_id = { valor: estructuraId };
    } else {
      gluedFilter['tipo.id'] = { valor: cdgtipo };
    }
    let numeroDeArticulos = 12;
    if (isTotem()) numeroDeArticulos = 9;
    return (
      <Page
        tituloTraduccionId="encargos.seleccionar_articulo"
        navigationItems={[
          {
            node: <Text translationId="navegacion.home" />,
            link: '',
          },
          {
            node: <Text translationId="navegacion.encargos" />,
          },
          {
            node: <Text>{`Nº ${encargoUUID}`}</Text>,
            link: `/encargos/crear`,
          },
        ]}
      >
        <TwoColumnsFlexLayout
          flexLeft={2}
          leftContent={(
            <Box>
              <BuscadorArticulos
                filtrosDesactivados={!!estructuraId}
                numeroDeArticulos={numeroDeArticulos}
                gluedFilter={gluedFilter}
                endpoint="BUSCADOR_ARTICULOS_CREAR_ENCARGO_PAGE"
                init
                ordenable={[
                  { label: 'Ordenar por nombre', value: 'descripcion' },
                  { label: 'Ordenar por precio', value: 'precio_1' },
                ]}
                onVRClick={(seleccion) => {
                  const { articuloId } = seleccion;
                  history.push({
                    pathname: `/encargos/crear/fittingBox/tipo/${cdgtipo}/encargo/${encargoUUID}/linea/${linea}/seleccion/${articuloId}`,
                  });
                }}

                onSeleccion={(seleccion) => {
                  const { articulo } = seleccion;
                  if (modoSeleccionGafa) {
                    seleccionarMonturaGafaGraduada({ articulo, encargoUUID, linea });
                    history.push(`/encargos/encargo/${encargoUUID}/seleccionarLente/linea/${parseInt(linea, 10) + 1}`);
                  } else {
                    addArticulo({ articulo, encargoUUID, linea });
                    history.goBack();
                  }
                }}
                styles={{
                  contenedorListado: { height: '400px', overflowY: 'scroll' },
                  contenedorListadoPaginacion: { minHeight: '470px' },
                }}
              />
            </Box>
          )}
          rightColumnStyle={{ paddingLeft: '16px' }}
          rightContent={(
            <Box style={{ position: 'sticky', top: '128px' }}>
              <ResumenEncargo />
            </Box>
          )}
        />
      </Page>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addArticulo,
    seleccionarMonturaGafaGraduada,
  }, dispatch);
}


const mapStateToProps = (state, ownProps) => {
  const { match } = ownProps;
  const { params: { encargoUUID, linea, cdgtipo } } = match;
  const { encargosCreador } = state;
  let detalleSeleccionado = null;
  let encargoSeleccionado = null;
  let estructuraId = null;
  if (encargosCreador) {
    const { encargos } = encargosCreador;
    if (encargos) {
      encargoSeleccionado = encargos.find(({ uuid }) => uuid === encargoUUID);
      if (encargoSeleccionado) {
        const { detalles } = encargoSeleccionado;
        detalleSeleccionado = detalles.find(detalle => detalle.linea == linea);
        if (detalleSeleccionado) estructuraId = detalleSeleccionado.estructuraId;
      }
    }
  }
  return {
    encargo: encargoSeleccionado,
    encargoUUID,
    linea,
    cdgtipo,
    estructuraId,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EncargosCrearSeleccionarArticuloPage);

EncargosCrearSeleccionarArticuloPage.propTypes = {
  addArticulo: PropTypes.func,
  seleccionarMonturaGafaGraduada: PropTypes.func,
  encargo: PropTypes.any,
  encargoUUID: PropTypes.string,
  estructuraId: PropTypes.number,
  history: PropTypes.any,
  linea: PropTypes.number,
  modoSeleccionGafa: PropTypes.bool,
};
